import { Tabs, TabsProps } from "antd";
import React from "react";
import { Products } from "../products";
import { ProductsEnquiries } from "./products";
import { ServicesEnquiries } from "./services";
export const Enquiries=()=>{
    const onChange = (key: string) => {
        console.log(key);
      };
const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Products',
      children: <ProductsEnquiries/>,
    },
    {
      key: '2',
      label: 'General',
      children: <ServicesEnquiries/>,
    },
  ];
    return(
        <div style={{display:"flex",flexDirection:"column",justifyContent:"flex-start",alignItems:"flex-start"}}> 
            <div style={{textAlign:"left",fontSize:28,fontWeight:600}}>Enquiries</div>
            <Tabs defaultActiveKey="1" items={items} onChange={onChange} style={{width:"100%"}} />
        </div>
    )
}